import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EmailService } from '../../../shared/services/email/email.service';
import { ISendEmail } from '../../../shared/services/email/send-email.model';
import { MessageService } from '../../../shared/services/message/message.service';
import { GatekeeperModalComponent } from '../../modal.component';

@Component({
  selector: 'gk-email-share-key-personnel-modal',
  templateUrl: './email-share-key-personnel-modal.component.html'
})
export class EmailShareKeyPersonnelModalComponent extends GatekeeperModalComponent<EmailShareKeyPersonnelModalComponent> {
  sendEmail: ISendEmail = <ISendEmail>{};

  constructor(
    private emailService: EmailService,
    private messageService: MessageService,
    private router: Router,
    public dialogRef: MatDialogRef<EmailShareKeyPersonnelModalComponent>
  ) {
    super();
  }

  emailExchangeKey() {
    return this.emailService
      .sendEmail(this.sendEmail)
      .then(() => this.messageService.showIcon(MessageTypeEnum.Success))
      .catch(reponse =>
        this.messageService.showMessage(
          MessageTypeEnum.Danger,
          reponse.error.detail,
          { name: '' }
        )
      )
      .then(() => this.close())
      .then(() => {
        this.router.navigate(['/setup/personnel']);
      });
  }
}
